export default __webpack_public_path__ + "static/kiln-6-9d0672fbc1895bcc0ccc503db3c66c7e.jpg";